class Article {

    title: string;
    content: string;
    publishedAt: Date;

    static fromJson(json: any): Article {
        const article: Article = new Article();
        article.title = json.title;
        article.content = json.content;
        article.publishedAt = new Date(json.publishedAt);
        return article;
    }
}

export default Article;